import React from "react";
import Table from "./Table";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {

  return <Table />;
};
